// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 149 ? "LandingPage" : chunkId) + "." + {"149":"e6c7045d","953":"e19bc237"}[chunkId] + ".css";
};